export default "__VITE_ASSET__5576d3e6__"